// TODO: Check and extract to these common models to SimplyGrow lib, as much of this code was copied from backend.

type ExtractionConfigItemKey = "targetKey" | "fallbackKey"
export type ExtractionConfigItem = Record<ExtractionConfigItemKey, string>
export type ExtractionConfig = ExtractionConfigItem[]
type DataFlowName = string
export type DocName = string
export type Division = string
export type JobType = string
export type JobSubType = string
type Event = string
export type Offence = string
type ActionFlowConfig = string[]
type Action = string
type TerminationReason = string
type TerminationSubReason = string
type UseProcessFlow = boolean | undefined
type DataCaptureConfig_BODY = { dataFlowNames: DataFlowName[] }
type DocCaptureConfig_BODY = { docNames: DocName[] }
type OffenceConfig_BODY = { actionExpiry: Record<string, number>; actionFlow: ActionFlowConfig }

type TreeBase<T> = Record<Division, Record<JobType, Record<JobSubType, T>>>
type TreeCompetency<T> = TreeBase<Record<DocName, T>>
type TreeOffence<T> = TreeBase<Record<Offence, Record<Action, T>>>
type TreeTermination<T> = TreeBase<Record<TerminationReason, Record<TerminationSubReason, T>>>

export enum ProcessType {
  adHocDocSign = "adHocDocSign",
  eventConfig = "eventConfig",
  competencies = "competenciesv2",
  generalEmployee = "generalEmployee",
  generalCandidate = "generalCandidate",
  discipline = "discipline",
  employ = "employ",
  promote = "promote",
  ppeIssue = "ppeIssue",
  ppeIssueRequest = "ppeIssueRequest",
  ppeReturn = "ppeReturn",
  ppeSizeSelection = "ppeSizeSelection",
  recruit = "recruit",
  transfer = "transfer",
  terminate = "terminate",
  viewData = "viewData",
}

export enum ProcessConfigType {
  dataFlowNames = "dataCaptureConfig",
  docNames = "docCaptureConfig",
  actionFlow = "offenceConfig",
  actionExpiry = "offenceConfig",
  requiredCompetencies = "competencyConfig",
}

export enum ProcessConfigCategoryEnums {
  dataFlowNames = "dataFlowNames",
  docNames = "docNames",
  actionFlow = "actionFlow",
  actionExpiry = "actionExpiry",
  requiredCompetencies = "requiredCompetencies",
}

export type SegmentInfo = {
  division?: string
  jobType?: string
  jobSubType?: string
  reasonForTermination?: string
  subReasonForTermination?: string
  eventType?: string
  action?: string
  offence?: string
  competencyName?: string
}

type DataCaptureConfigEmployment = TreeBase<DataCaptureConfig_BODY>
type DocCaptureConfigEmployment = TreeBase<DocCaptureConfig_BODY>

type DataCaptureConfigCompetencies = TreeCompetency<DataCaptureConfig_BODY>
type DocCaptureConfigCompetencies = TreeCompetency<DocCaptureConfig_BODY>
type CompetencyConfigV2 = TreeCompetency<{ requiredCompetencies: string[] }>

type DataCaptureConfigDiscipline = TreeOffence<DataCaptureConfig_BODY>
type DocCaptureConfigDiscipline = TreeOffence<DocCaptureConfig_BODY>

export type SingleOffenceConfig = Record<Division, Record<JobType, Record<JobSubType, OffenceConfig_BODY>>>
type OffenceConfig = Record<Offence, SingleOffenceConfig>

type DataCaptureConfigEvents = Record<Event, DataCaptureConfig_BODY>
type DocCaptureConfigEvents = Record<Event, DocCaptureConfig_BODY>

type DataCaptureConfigTermination = TreeTermination<DataCaptureConfig_BODY>
type DocCaptureConfigTermination = TreeTermination<DocCaptureConfig_BODY>
type TerminationReasonConfig = Record<TerminationReason, Record<TerminationSubReason, {}>>

type ICompetenciesV2Dto = {
  competencyConfig: CompetencyConfigV2
  dataCaptureConfig: DataCaptureConfigCompetencies
  docCaptureConfig: DocCaptureConfigCompetencies
  useProcessFlow: UseProcessFlow
}

type IDisciplineConfigDto = {
  offenceConfig: OffenceConfig
  dataCaptureConfig: DataCaptureConfigDiscipline
  docCaptureConfig: DocCaptureConfigDiscipline
  useProcessFlow: UseProcessFlow
  poorPerformanceOffenceName: string
}

type IEventsConfigDto = {
  dataCaptureConfig: DataCaptureConfigEvents
  docCaptureConfig: DocCaptureConfigEvents
  useProcessFlow: UseProcessFlow
}

type IGenericConfigDto = {
  dataCaptureConfig: DataCaptureConfigEmployment
  docCaptureConfig: DocCaptureConfigEmployment
  useProcessFlow: UseProcessFlow
}

type ITerminationConfigDto = {
  dataCaptureConfig: DataCaptureConfigTermination
  docCaptureConfig: DocCaptureConfigTermination
  terminationReasonConfig: TerminationReasonConfig
  useProcessFlow: UseProcessFlow
}

const {
  competencies,
  generalEmployee,
  generalCandidate,
  promote,
  transfer,
  terminate,
  employ,
  discipline,
  eventConfig,
} = ProcessType

export type ProcessConfigSchema = {
  [competencies]: ICompetenciesV2Dto
  [discipline]: IDisciplineConfigDto
  [employ]: IGenericConfigDto
  [eventConfig]: IEventsConfigDto
  [generalCandidate]: IGenericConfigDto
  [generalEmployee]: IGenericConfigDto
  [promote]: IGenericConfigDto
  [terminate]: ITerminationConfigDto
  [transfer]: IGenericConfigDto
}
